import { MapContext } from 'components/Mapbox/Mapbox'
import { CTRLPositions } from 'components/Mapbox/Types/mapboxtypes'
import mapboxgl from 'mapbox-gl'
import { useContext, useEffect } from 'react'

export const NavigationControl = ({
  position = 'top-right',
}: {
  position?: CTRLPositions
}) => {
  var context = useContext(MapContext)

  function addControl() {
    if (!context.map) return
    context.map.addControl(new mapboxgl.NavigationControl())
  }
  useEffect(() => {
    addControl()
  }, [position, context.map])

  return null
}
